import React, { Component } from "react";
import {
  Row,
  Col,
  Input,
  Form,
} from "antd";

class SecProfileInformation extends Component {
  state = {
    detailForm: null,
    preLoadOnsubmit: false,
    loadingFullpage: true,
  };
  
  render() {
    const { propFormInput, isViewOnly, rawData } = this.props;
    const {} = this.state;

    console.log("rawData tab1",rawData)

    return (
      <div className="box-color-white">
        <Row
          gutter={16}
          type="flex"
          justify="left"
          align="top"
        >
          <Col xs={24} md={24} className="">
            <strong className="color-red">ข้อมูลบุคลากร :</strong>
          </Col>
        </Row>
        <Row gutter={16} type="flex" justify="left" align="top" className="">
          <Col xs={8} md={8} className="pt-2" align="left">
            <Form.Item label={"ชื่อบุคลากร"} style={{ marginBottom: "0px" }}>
              {propFormInput.getFieldDecorator("empFullName", {
                initialValue: rawData?.abTimeHdId ? rawData.title+''+rawData.firstName+' '+rawData.lastName : rawData.fullName ,
              })(<Input disabled={true}/>)}
            </Form.Item>
          </Col>
          <Col xs={8} md={8} className="pt-2" align="left">
            <Form.Item label={"ฝ่าย"} style={{ marginBottom: "0px" }}>
              {propFormInput.getFieldDecorator("divisionName", {
                initialValue: rawData?.divisionName ? rawData.divisionName : "-" ,
            })(<Input disabled={true}/>)}
            </Form.Item>
          </Col>
          <Col xs={8} md={8} className="pt-2" align="left">
            <Form.Item label={"หน่วยงาน"} style={{ marginBottom: "0px" }}>
              {propFormInput.getFieldDecorator("buName", {
                initialValue: rawData?.buName ? rawData.buName : "-" ,
            })(<Input disabled={true}/>)}
            </Form.Item>
          </Col>
        </Row>
      </div>
    );
  }
}

export default SecProfileInformation
